const SELETOR_ICON = 'link[rel~="icon"]';
const FAVICON_BASE = '/favicon/favicon-32x32.png';
const PREFIXO_TITULO = /^\(\d+\+?\)\s+/;

let linksOriginais = null;
let imagemBase = null;
let contador = 0;
let observer = null;
let tituloBase = typeof document !== 'undefined' ? document.title : 'LAIS';

const limparTitulo = (titulo) => String(titulo || '').replace(PREFIXO_TITULO, '');

function aplicarTitulo() {
  const atual = limparTitulo(document.title);
  if (atual) tituloBase = atual;
  const rotulo = contador > 99 ? '99+' : String(contador);
  document.title = contador > 0 ? `(${rotulo}) ${tituloBase}` : tituloBase;
}

function guardarOriginais() {
  if (linksOriginais) return;
  linksOriginais = [...document.querySelectorAll(SELETOR_ICON)].map((link) => ({
    rel: link.getAttribute('rel'),
    sizes: link.getAttribute('sizes'),
    type: link.getAttribute('type'),
    href: link.getAttribute('href'),
  }));
}

const carregarBase = () =>
  new Promise((resolve, reject) => {
    if (imagemBase) return resolve(imagemBase);
    const img = new Image();
    img.onload = () => {
      imagemBase = img;
      resolve(img);
    };
    img.onerror = reject;
    // Mesma origem: o canvas nao fica tainted e o toDataURL funciona.
    img.src = FAVICON_BASE;
  });

function aplicarFavicon(href) {
  document.querySelectorAll(SELETOR_ICON).forEach((link) => link.remove());
  const link = document.createElement('link');
  link.id = 'lais-favicon-dinamico';
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = href;
  document.head.appendChild(link);
}

function restaurarFavicon() {
  if (!linksOriginais) return;
  document.querySelectorAll(SELETOR_ICON).forEach((link) => link.remove());
  linksOriginais.forEach((attrs) => {
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([chave, valor]) => {
      if (valor != null) link.setAttribute(chave, valor);
    });
    document.head.appendChild(link);
  });
}

async function desenharFavicon() {
  guardarOriginais();
  if (contador <= 0) return restaurarFavicon();

  const img = await carregarBase().catch(() => null);
  const canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  if (img) ctx.drawImage(img, 0, 0, 32, 32);

  const rotulo = contador > 9 ? '9+' : String(contador);
  ctx.beginPath();
  ctx.arc(23, 9, 9, 0, Math.PI * 2);
  ctx.fillStyle = '#EF4444';
  ctx.fill();
  ctx.lineWidth = 2;
  ctx.strokeStyle = '#FFFFFF';
  ctx.stroke();

  ctx.fillStyle = '#FFFFFF';
  ctx.font = `bold ${contador > 9 ? 10 : 12}px -apple-system, "Segoe UI", sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(rotulo, 23, 10);

  aplicarFavicon(canvas.toDataURL('image/png'));
  return undefined;
}

export function setUnreadCount(valor) {
  const proximo = Math.max(0, Number(valor) || 0);
  if (proximo === contador) return;
  contador = proximo;
  aplicarTitulo();
  desenharFavicon().catch((err) => console.debug('[notificacoes] favicon nao atualizou', err));
}

export const getUnreadCount = () => contador;

/**
 * Todas as paginas usam `<Helmet><title>...</title></Helmet>` (components/Page.js),
 * entao qualquer navegacao reescreve o <title> e apagaria o contador. O observer
 * reaplica o prefixo sempre que isso acontece.
 */
export function startBadge() {
  if (observer || typeof document === 'undefined') return;
  const elemento = document.querySelector('title');
  if (!elemento) return;

  observer = new MutationObserver(() => {
    if (contador > 0 && !PREFIXO_TITULO.test(document.title)) aplicarTitulo();
  });
  observer.observe(elemento, { childList: true, characterData: true, subtree: true });
}

export function stopBadge() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  setUnreadCount(0);
}
